import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import AppLandingPage from "../../All_Projects_Landing_Pages/AppLandingPage";
import { FieldsProvider } from "../../../context/FieldsContext";
import {
  getImagesFromDB,
  fetchAndStoreImages,
} from "../../../utils/imageUtils";
import COPDComponent from "../../All_Project_Components/CopdComponent";
import Report from "../../common/Report";
import COPDPdfDetails from "../../../components/pdfReports/COPDPdfReport";
const COPDRoutes = (props) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formDetails, setFormDetails] = useState({});
  const [PdfInfo, setPDFDetails] = useState({});
  const [units, setUnits] = useState({});

  const app = "aicopd";
  const COPD_LANDING_URL =
    "https://clinical-server-apis.azurewebsites.net/fields/aicopd";
  const COPD_AQI_URL =
    "https://clinical-server-apis.azurewebsites.net/copd/aqi?pincode=";
  const COPD_REPORT_URL = "https://clinical-server-apis.azurewebsites.net/copd";
  const color = "#5fa8d3";
  const secondaryColor = " #73b3d9";
  const button_hover_color = "#afd4e9";
  const surface_color = "#fbf3fb";
  const surface_hover_color = "#e8e0e8";
  const surface_highlight_color = "#dcdaf5";
  const gender_highlight_color = "#675496";
  const button_color = "rgb(123, 104, 171)";
  const surface_highlight_dark_color = "rgb(103, 84, 150)";

  const form_details = (props) => {
    const details = {
      patient_id: props.patient_id,
      name: props.name,
      age: props.age,
      gender: props.gender,
      location: props.location,
      email: props.email,
      phone: props.phone,
      patient_current_suffering: props.patient_current_suffering,
      allergies: props.allergies,
      food_allergies: props.food_allergies,
      medicine_allergies: props.medicine_allergies,
      respiratory_medication: props.respiratory_medication,
      covid_vaccine_brand: props.covid_vaccine_brand,
      covid_vaccine_date: props.covid_vaccine_date,
      influenza_vaccine_date: props.influenza_vaccine_date,
      aqi: props.airIndex,
      smoking: props.smoking,
      tobacco: props.tobacco,
      patient_history: props.patient_history,
      breathlessness: props.breathlessness,
      sputum: props.sputum,
      medical_history_lungs: props.medical_history_lungs,
      rate_of_respiration: props.rate_of_respiration,
      pulse_rate_change: props.pulse_rate_change,
      spo2: props.spo2,
      chest_auscultation_wheezes: props.chest_auscultation_wheezes,
    };

    const pdf_details = {
      basic_info: {
        UHID: props.patient_id,
        Name: props.name,
        Age: props.age,
        Gender: props.gender,
        Location: props.location,
        Mobile: props.phone,
      },
      "Past History": {
        Allergies: props.allergies,
        "Pulmonary History": props.patient_current_suffering,
        Medication: props.respiratory_medication,
        "COVID-19 Vaccine": props.covid_vaccine_brand,
        "COVID-19 Vaccine Date": props.covid_vaccine_date,
        "Influenza Vaccine Date": props.influenza_vaccine_date,
      },
      "Medical History": {
        "Air quality index (AQI)": props.airIndex,
        "Does the patient use any one the drugs listed below?":
          props.medical_history_lungs,
        "Has the patient's pulse rate increased by 10% from baseline recently?":
          props.pulse_rate_change,
        Breathlessness: props.breathlessness,
        Sputum: props.sputum,
        "Rate of Respiration": props.rate_of_respiration,
        // "Pulse Rate Change": props.pulse_rate_change,
        SPO2: props.spo2,
        "Chest Auscultation Wheezes": props.chest_auscultation_wheezes,
        "Tuberculosis or Heart Disease":props.patient_history,
        Smoking: props.smoking,
        Tobacco: props.tobacco,
      },
    };

    const units = {
      "Rate of Respiration": "/min",
      SPO2: "%",
    };

    setUnits(units);

    setFormDetails(details);
    setPDFDetails(pdf_details);
  };

  useEffect(() => {
    const loadImages = async () => {
      try {
        const storedImages = await getImagesFromDB(app);
        if (storedImages.length > 0) {
          setImages(storedImages);
        } else {
          const urls = [
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo-logo.png",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/aicopd-landing-image.png",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/aicopd-app-page-1.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/aicopd-app-page-2.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/aicopd-intepretation-img.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo_certificate_MD%20763515.png",
          ];
          await fetchAndStoreImages(app, urls, setImages);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        setLoading(false); // End loading
      }
    };
    loadImages();
  }, []);

  return (
    <FieldsProvider>
      <Routes>
        <Route
          path="/"
          element={
            <AppLandingPage
              LANDING_URL={COPD_LANDING_URL}
              app={app}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              secondaryColor={secondaryColor}
              images={images}
              loading={loading}
              button_hover_color={button_hover_color}
            />
          }
        />
        <Route
          path="patient-details"
          element={
            <COPDComponent
              app={app}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
              gender_highlight_color={gender_highlight_color}
              surface_highlight_dark_color={surface_highlight_dark_color}
              button_color={button_color}
              form_details={form_details}
              COPD_AQI_URL={COPD_AQI_URL}
            />
          }
        />
        <Route
          path="report"
          element={
            <Report
              app={app}
              formDetails={formDetails}
              REPORT_URL={COPD_REPORT_URL}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
            />
          }
        />
        <Route
          app={app}
          path="pdfreport"
          element={
            <COPDPdfDetails
              formDetails={formDetails}
              PdfInfo={PdfInfo}
              color={color}
              units={units}
            />
          }
        />
      </Routes>
    </FieldsProvider>
  );
};

export default COPDRoutes;
